import React from 'react';
import { Box, Typography } from '@mui/material';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 8,
        py: 4,
        px: 3,
        borderTop: '1px solid rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} Jake Bringetto
      </Typography>

      <Box sx={{ display: 'flex', gap: 2.5 }}>
        {[
          { href: 'https://github.com/jakeBringetto', icon: <FaGithub size={18} /> },
          { href: 'https://linkedin.com/in/jakebringetto', icon: <FaLinkedin size={18} /> },
          { href: 'mailto:jakebringetto@berkeley.edu', icon: <FaEnvelope size={18} /> },
        ].map(({ href, icon }) => (
          <a
            key={href}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#888', display: 'flex', alignItems: 'center', transition: 'color 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#2563EB'}
            onMouseLeave={e => e.currentTarget.style.color = '#888'}
          >
            {icon}
          </a>
        ))}
      </Box>
    </Box>
  );
}

export default Footer;
